export const mapStateToProps = state => ({
  adminToken: state.auth.adminToken,
});

export const mapDispatchToProps = () => ({

});
